import React from "react";
import { MapContainer, TileLayer, Popup, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import markerIconPng from "leaflet/dist/images/marker-icon.png"
import {Icon} from 'leaflet'
const center = [35.6999838, 51.3382364];
const zoom = 16;

export default function Map({origin_lat , origin_long ,destination_lat ,destination_long}) {
  const position = [origin_long ,origin_lat];
  const position2 = [destination_lat ,destination_long];
  return (
    <>
      <MapContainer style={{height:'150px'}} center={position} zoom={10} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker  icon={new Icon({iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41]})}  position={position}>
          <Popup>مبدا</Popup>
        </Marker>
        <Marker  icon={new Icon({iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41]})}  position={position2}>
          <Popup>مقصد</Popup>
        </Marker>
      </MapContainer>
    </>
  );
}
